// extracted by mini-css-extract-plugin
export default {"CalculatorPage":"calculatorPage_CalculatorPage__7GkX7"};